import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type PayrollMonthExpenseInstructionModalAnalyticIds = {
  payrollMonthExpenseUploadBtnId: string;
  payrollMonthExpenseCancelBtnId: string;
};

export const usePayrollMonthExpenseInstructionModalAnalyticIds =
  (): PayrollMonthExpenseInstructionModalAnalyticIds => ({
    payrollMonthExpenseUploadBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_PAYROLL_MONTH_EXPENSE_UPLOAD_BUTTON),
    payrollMonthExpenseCancelBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_PAYROLL_MONTH_EXPENSE_CANCEL_BUTTON),
  });
